<div class="tw-mb-4">
  <label
    class="tw-mb-1 tw-block tw-text-sm tw-font-medium tw-text-night"
    [attr.for]="id"
    >{{ props.label }}</label
  >
  <ng-container #fieldComponent></ng-container>
  @if (field.props?.description) {
    <small class="tw-mt-1 tw-block tw-text-sm tw-text-night-3">{{
      field.props?.description
    }}</small>
  }
</div>
